module.exports = __webpack_public_path__ + "static/media/sad.2d09f7da.png";